<template>
    <div>

        <div class="container-fluid">
            <div class="row">

                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                        <month-picker-input @input="showDate" lang="es" :default-month="date.month" :default-year="date.year"></month-picker-input>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                        <toggle-button @change="filtroWeb" tabindex="20" v-model="web" color="#e3985f" :width="150" :height="40" :labels="{checked: 'Córdoba', unchecked: 'Sevilla'}"/>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <v-select
                                v-model="selectTours"
                                :items="tours"
                                item-text="text"
                                item-value="idioma"
                                label="Tour seleccionado: "
                                persistent-hint
                                return-object
                                outline
                                v-on:change="fillData"

                        ></v-select>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <v-select
                                v-model="empleado"
                                :items="empleados"
                                label="Empleado:"
                                outline
                                v-on:change="fillData"
                        ></v-select>
                    </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <line-chart :chart-data="dataChartMes" :options="optionsChartMes"></line-chart>
                    </div>

                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="green"
                                            icon="mdi-account"
                                            :value="totalPersonasMes"
                                            title="Personas"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalPersonasMesBest}}</strong></li>
                                    </ul>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="yellow"
                                            icon="mdi-currency-eur"
                                            :value="totalEconomicoMes"
                                            title="Económico"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalEconomicoBest}}</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <line-chart :chart-data="dataChartYear" :options="optionsChartYear"></line-chart>
                    </div>

                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="green"
                                            icon="mdi-account"
                                            :value="totalPersonasYear"
                                            title="Personas"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor mes: <strong>{{totalPersonasYearBest}}</strong></li>
                                    </ul>

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="yellow"
                                            icon="mdi-currency-eur"
                                            :value="totalEconomicoYear"
                                            title="Económico"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor mes: <strong>{{totalEconomicoYearBest}}</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <line-chart :chart-data="dataChartEmpleado" :options="optionsChartEmpleado"></line-chart>
                    </div>

                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="green"
                                            icon="mdi-account"
                                            :value="totalPersonasEmpleado"
                                            title="Personas"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalPersonasEmpleadoBest}}</strong></li>
                                    </ul>

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="yellow"
                                            icon="mdi-currency-eur"
                                            :value="totalEconomicoEmpleado"
                                            title="Económico"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalEconomicoEmpleadoBest}}</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <line-chart :chart-data="dataChartTour" :options="optionsChartTour"></line-chart>
                    </div>

                    <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="green"
                                            icon="mdi-account"
                                            :value="totalPersonasTour"
                                            title="Personas"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalPersonasTourBest}}</strong></li>
                                    </ul>

                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                                    <material-stats-card
                                            color="yellow"
                                            icon="mdi-currency-eur"
                                            :value="totalEconomicoTour"
                                            title="Económico"


                                    />
                                    <ul class="list-group">
                                        <li class="list-group-item">Mejor día: <strong>{{totalEconomicoTourBest}}</strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>




    </div>

</template>

<script>

//import MonthPicker from 'vue-month-picker'
import axios from 'axios'
import LineChart from './personasMes.js'
import { ToggleButton } from 'vue-js-toggle-button'
import chartjsPluginAnnotation from "chartjs-plugin-annotation";

//axios.defaults.baseURL = 'http://localhost/FreeTourControl/api'
axios.defaults.baseURL = 'https://app.freetoursevilla.es/api'

export default {
    components: {
        LineChart,
      ToggleButton,
      chartjsPluginAnnotation
    },
  data () {
    return {
      date: {
        from: null,
        to: null,
        month: null,
        monthIndex: null,
        year: null
      },
      web: false,//false es sevilla y true es cordoba
      selectTours: { text: 'Todos', idioma: 'Todos_0' },
      tours: [
        { text: 'Todos', idioma: 'Todos_0' },
        { text: 'Todos (Español)', idioma: 'Todos_1' },
        { text: 'Todos (Ingles)', idioma: 'Todos_2' },
        { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1' },
        { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2' },
        { text: 'Free Tour Misterios de Santa Cruz (Español)', idioma: 'Santa Cruz_1' },
        { text: 'Free Tour Leyendas de Triana (Español)', idioma: 'Triana_1' },
        { text: 'Free Tour Misterios de Santa Cruz (Ingles)', idioma: 'Santa Cruz_2' },
        { text: 'Flamenco Tour (Español)', idioma: 'Flamenco Tour_1' },
        { text: 'Flamenco Tour (Ingles)', idioma: 'Flamenco Tour_2' },
        { text: 'Bike Tour (Español)', idioma: 'Bike Tour_1' },
        { text: 'Bike Tour (Ingles)', idioma: 'Bike Tour_2' },
        { text: 'Free Tour Leyendas de Triana (Ingles)', idioma: 'Triana_2' },
        { text: 'Tour de las 12 (Español)', idioma: 'Tour de las 12_1' },
        { text: 'Tour de las 12 (Ingles)', idioma: 'Tour de las 12_2' },
        { text: 'Flamenco Ticket', idioma: 'Flamenco Ticket (Sin distinción de idioma)_1' },
        { text: 'Especial', idioma: 'Especial_1' },
        { text: 'Alcázar', idioma: 'Alcázar_1' },
        { text: 'Especial Italiano', idioma: 'Especial Italiano_1' },
        { text: 'Free Tour Monumental (Francés)', idioma: 'Casco Histórico_3' },
        { text: 'Free Tour Misterios de Santa Cruz 12:45h (Español)', idioma: 'Santa Cruz 12-45_1' },
        { text: 'Free Tour Misterios de Santa Cruz 12:45h (Inglés)', idioma: 'Santa Cruz 12-45_2' },
        { text: 'Viator', idioma: 'Viator (Sin distinción de idioma)_1' },
        { text: 'Ronda y Granada', idioma: 'Ronda y Granada (Sin distinción de idioma)_1' }
      ],
      empleados:[],
      empleado:"Todos",

      dataChartMes: null,
      optionsChartMes: null,
      totalPersonasMes:0,
      totalPersonasMesBest:"",
      totalEconomicoMes:0,
      totalEconomicoBest:"",
      promedioPersonasMes:"",
      promedioEconomicoMes:"",

      dataChartYear: null,
      optionsChartYear: null,
      totalPersonasYear:0,
      totalPersonasYearBest:"",
      totalEconomicoYear:0,
      totalEconomicoYearBest:"",
      promedioPersonasYear:"",
      promedioEconomicoYear:"",

      dataChartEmpleado: null,
      optionsChartEmpleado: null,
      totalPersonasEmpleado:0,
      totalPersonasEmpleadoBest:"",
      totalEconomicoEmpleado:0,
      totalEconomicoEmpleadoBest:"",
      promedioPersonasEmpleado:"",
      promedioEconomicoEmpleado:"",

      dataChartTour: null,
      optionsChartTour: null,
      totalPersonasTour:0,
      totalPersonasTourBest:"",
      totalEconomicoTour:0,
      totalEconomicoTourBest:"",
      promedioPersonasTour:"",
      promedioEconomicoTour:"",








    }
  },
    created() {

        this.date.year = new Date().getFullYear();
        this.date.month = new Date().getMonth()+1;

        this.date.monthIndex = this.date.month;

        this.getEmpleados();
    },
    mounted () {
        this.fillData();

    },
  methods: {
        filtroWeb(){

          if(!this.web){
            this.selectTours = { text: 'Todos', idioma: 'Todos_0' };
            this.tours= [
              { text: 'Todos', idioma: 'Todos_0' },
              { text: 'Todos (Español)', idioma: 'Todos_1' },
              { text: 'Todos (Ingles)', idioma: 'Todos_2' },
              { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1' },
              { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2' },
              { text: 'Free Tour Misterios de Santa Cruz (Español)', idioma: 'Santa Cruz_1' },
              { text: 'Free Tour Leyendas de Triana (Español)', idioma: 'Triana_1' },
              { text: 'Free Tour Misterios de Santa Cruz (Ingles)', idioma: 'Santa Cruz_2' },
              { text: 'Flamenco Tour (Español)', idioma: 'Flamenco Tour_1' },
              { text: 'Flamenco Tour (Ingles)', idioma: 'Flamenco Tour_2' },
              { text: 'Bike Tour (Español)', idioma: 'Bike Tour_1' },
              { text: 'Bike Tour (Ingles)', idioma: 'Bike Tour_2' },
              { text: 'Free Tour Leyendas de Triana (Ingles)', idioma: 'Triana_2' },
              { text: 'Tour de las 12 (Español)', idioma: 'Tour de las 12_1' },
              { text: 'Tour de las 12 (Ingles)', idioma: 'Tour de las 12_2' },
              { text: 'Flamenco Ticket', idioma: 'Flamenco Ticket (Sin distinción de idioma)_1' },
              { text: 'Especial', idioma: 'Especial_1' },
              { text: 'Alcázar', idioma: 'Alcázar_1' },
              { text: 'Especial Italiano', idioma: 'Especial Italiano_1' },
              { text: 'Free Tour Monumental (Francés)', idioma: 'Casco Histórico_3' },
              { text: 'Free Tour Misterios de Santa Cruz 12:45h (Español)', idioma: 'Santa Cruz 12-45_1' },
              { text: 'Free Tour Misterios de Santa Cruz 12:45h (Inglés)', idioma: 'Santa Cruz 12-45_2' },
              { text: 'Viator', idioma: 'Viator (Sin distinción de idioma)_1' },
              { text: 'Ronda y Granada', idioma: 'Ronda y Granada (Sin distinción de idioma)_1' }
            ];
          }else{
            this.selectTours = { text: 'Todos', idioma: 'Todos_0' };
            this.tours= [
              { text: 'Todos', idioma: 'Todos_0' },
              { text: 'Todos (Español)', idioma: 'Todos_1' },
              { text: 'Todos (Ingles)', idioma: 'Todos_2' },
              { text: 'Free Tour Monumental (Español)', idioma: 'Casco Histórico_1' },
              { text: 'Free Tour Monumental (Ingles)', idioma: 'Casco Histórico_2' },
              { text: 'Free Tour Leyendas Juderia (Español)', idioma: 'Leyendas Juderia_1' },
              { text: 'Free Tour Leyendas Juderia (Ingles)', idioma: 'Leyendas Juderia_2' }
              ];
          }

          this.getEmpleados();

        },
        getChartMes(){
            let formData = new FormData();

            formData.append('month', this.date.monthIndex);
            formData.append('year', this.date.year);
            formData.append('tour', this.selectTours.idioma);
            formData.append('empleado', this.empleado);
            formData.append('web', this.web);
            formData.append('chart', "mes");

            axios.post('/get.charts.personas.php', formData)
              .then(response => {

                //this.dataChartMes = response.data;
                this.dataChartMes = {
                  labels: response.data.personas.labels,
                  datasets: [
                    {
                      label: [response.data.economico.datasets.label],
                      //backgroundColor: response.data.datasets.backgroundColor,
                      data: response.data.economico.datasets.data,
                      type: 'line',
                      borderColor: "#ff9800"
                    },
                    {
                      label: [response.data.personas.datasets.label],
                      backgroundColor: response.data.personas.datasets.backgroundColor,
                      data: response.data.personas.datasets.data
                    }
                  ]
                }

                this.totalPersonasMes = response.data.personas.totalPersonas;
                this.totalPersonasMesBest = response.data.personas.totalPersonasMesBest;
                this.totalEconomicoMes = response.data.economico.totalEconomico;
                this.totalEconomicoBest = response.data.economico.totalEconomicoBest;

                this.optionsChartMes = {
                  responsive: true,
                  maintainAspectRatio: true,
                  scales: {
                    yAxes: [{
                      ticks: {
                        beginAtZero:true
                      }
                    }]
                  },
                  title: {
                    display: true,
                    text: 'Datos/Mes'
                  },
                  annotation: {
                    // Defines when the annotations are drawn.
                    // This allows positioning of the annotation relative to the other
                    // elements of the graph.
                    //
                    // Should be one of: afterDraw, afterDatasetsDraw, beforeDatasetsDraw
                    // See http://www.chartjs.org/docs/#advanced-usage-creating-plugins
                    drawTime: 'afterDatasetsDraw', // (default)
                    // Mouse events to enable on each annotation.
                    // Should be an array of one or more browser-supported mouse events
                    // See https://developer.mozilla.org/en-US/docs/Web/Events
                    events: ['click'],
                    // Double-click speed in ms used to distinguish single-clicks from
                    // double-clicks whenever you need to capture both. When listening for
                    // both click and dblclick, click events will be delayed by this
                    // amount.
                    dblClickSpeed: 350, // ms (default)
                    // Array of annotation configuration objects
                    // See below for detailed descriptions of the annotation options
                    annotations: [{
                     // drawTime: 'afterDatasetsDraw', // overrides annotation.drawTime if set
                      id: 'a-line-1', // optional
                      type: 'line',
                      mode: 'horizontal',
                      scaleID: 'y-axis-0',
                      value: response.data.personas.promedioPersonas,
                      borderColor: 'green',
                      borderWidth: 2,
                      label: {
                        // Background color of label, default below
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        // Font family of text, inherits from global
                        fontFamily: "sans-serif",
                        // Font size of text, inherits from global
                        fontSize: 12,
                        // Font style of text, default below
                        fontStyle: "bold",
                        // Font color of text, default below
                        fontColor: "#fff",
                        // Padding of label to add left/right, default below
                        xPadding: 6,
                        // Padding of label to add top/bottom, default below
                        yPadding: 6,
                        // Radius of label rectangle, default below
                        cornerRadius: 6,
                        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                        position: "left",
                        // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                        // For horizontal lines positioned left or right, negative values move
                        // the label toward the edge, and positive values toward the center.
                        xAdjust: 0,
                        // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                        // For vertical lines positioned top or bottom, negative values move
                        // the label toward the edge, and positive values toward the center.
                        yAdjust: 0,
                        // Whether the label is enabled and should be displayed
                        enabled: true,
                        // Text to display in label - default is null
                        content: "Promedio Personas ("+response.data.personas.promedioPersonas+")"
                      },
                      // Fires when the user clicks this annotation on the chart
                      // (be sure to enable the event in the events array below).
                      onClick: function(e) {
                        // `this` is bound to the annotation element
                      }
                    },

                      {
                        //drawTime: 'afterDraw', // overrides annotation.drawTime if set
                        id: 'a-line-2', // optional
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'y-axis-0',
                        value: response.data.economico.promedioEconomico,
                        borderColor: 'yellow',
                        borderWidth: 2,
                        label: {
                          // Background color of label, default below
                          backgroundColor: 'rgba(0,0,0,0.8)',
                          // Font family of text, inherits from global
                          fontFamily: "sans-serif",
                          // Font size of text, inherits from global
                          fontSize: 12,
                          // Font style of text, default below
                          fontStyle: "bold",
                          // Font color of text, default below
                          fontColor: "#fff",
                          // Padding of label to add left/right, default below
                          xPadding: 6,
                          // Padding of label to add top/bottom, default below
                          yPadding: 6,
                          // Radius of label rectangle, default below
                          cornerRadius: 6,
                          // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                          position: "right",
                          // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                          // For horizontal lines positioned left or right, negative values move
                          // the label toward the edge, and positive values toward the center.
                          xAdjust: 0,
                          // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                          // For vertical lines positioned top or bottom, negative values move
                          // the label toward the edge, and positive values toward the center.
                          yAdjust: 0,
                          // Whether the label is enabled and should be displayed
                          enabled: true,
                          // Text to display in label - default is null
                          content: "Promedio € ("+response.data.economico.promedioEconomico+")"
                        },
                        // Fires when the user clicks this annotation on the chart
                        // (be sure to enable the event in the events array below).
                        onClick: function(e) {
                          // `this` is bound to the annotation element
                        }
                      }
                    ],



                  }


                }
              })
              .catch(error => {
                console.log(error);
              })
          },
        getChartYear(){
          let formData = new FormData();

          formData.append('year', this.date.year);
          formData.append('tour', this.selectTours.idioma);
          formData.append('empleado', this.empleado);
          formData.append('web', this.web);
          formData.append('chart', "year");

          axios.post('/get.charts.personas.php', formData)
            .then(response => {

              //this.dataChartMes = response.data;

              this.dataChartYear = {
                labels: response.data.personas.labels,
                datasets: [
                  {
                    label: [response.data.economico.datasets.label],
                    //backgroundColor: response.data.datasets.backgroundColor,
                    data: response.data.economico.datasets.data,
                    type: 'line',
                    borderColor: "#ff9800"
                  },
                  {
                    label: [response.data.personas.datasets.label],
                    backgroundColor: response.data.personas.datasets.backgroundColor,
                    data: response.data.personas.datasets.data
                  }
                ]
              }

              console.log(response.data)

              this.totalPersonasYear = response.data.personas.totalPersonas;
              this.totalPersonasYearBest = response.data.personas.totalPersonasBest;
              this.totalEconomicoYear = response.data.economico.totalEconomico;
              this.totalEconomicoYearBest = response.data.economico.totalEconomicoBest;

              this.optionsChartYear = {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero:true
                    }
                  }]
                },
                title: {
                  display: true,
                  text: 'Datos/Año'
                },
                annotation: {
                  // Defines when the annotations are drawn.
                  // This allows positioning of the annotation relative to the other
                  // elements of the graph.
                  //
                  // Should be one of: afterDraw, afterDatasetsDraw, beforeDatasetsDraw
                  // See http://www.chartjs.org/docs/#advanced-usage-creating-plugins
                  drawTime: 'afterDatasetsDraw', // (default)
                  // Mouse events to enable on each annotation.
                  // Should be an array of one or more browser-supported mouse events
                  // See https://developer.mozilla.org/en-US/docs/Web/Events
                  events: ['click'],
                  // Double-click speed in ms used to distinguish single-clicks from
                  // double-clicks whenever you need to capture both. When listening for
                  // both click and dblclick, click events will be delayed by this
                  // amount.
                  dblClickSpeed: 350, // ms (default)
                  // Array of annotation configuration objects
                  // See below for detailed descriptions of the annotation options
                  annotations: [{
                    // drawTime: 'afterDatasetsDraw', // overrides annotation.drawTime if set
                    id: 'a-line-1', // optional
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: response.data.personas.promedioPersonas,
                    borderColor: 'green',
                    borderWidth: 2,
                    label: {
                      // Background color of label, default below
                      backgroundColor: 'rgba(0,0,0,0.8)',
                      // Font family of text, inherits from global
                      fontFamily: "sans-serif",
                      // Font size of text, inherits from global
                      fontSize: 12,
                      // Font style of text, default below
                      fontStyle: "bold",
                      // Font color of text, default below
                      fontColor: "#fff",
                      // Padding of label to add left/right, default below
                      xPadding: 6,
                      // Padding of label to add top/bottom, default below
                      yPadding: 6,
                      // Radius of label rectangle, default below
                      cornerRadius: 6,
                      // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                      position: "left",
                      // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                      // For horizontal lines positioned left or right, negative values move
                      // the label toward the edge, and positive values toward the center.
                      xAdjust: 0,
                      // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                      // For vertical lines positioned top or bottom, negative values move
                      // the label toward the edge, and positive values toward the center.
                      yAdjust: 0,
                      // Whether the label is enabled and should be displayed
                      enabled: true,
                      // Text to display in label - default is null
                      content: "Promedio Personas ("+response.data.personas.promedioPersonas+")"
                    },
                    // Fires when the user clicks this annotation on the chart
                    // (be sure to enable the event in the events array below).
                    onClick: function(e) {
                      // `this` is bound to the annotation element
                    }
                  },

                    {
                      //drawTime: 'afterDraw', // overrides annotation.drawTime if set
                      id: 'a-line-2', // optional
                      type: 'line',
                      mode: 'horizontal',
                      scaleID: 'y-axis-0',
                      value: response.data.economico.promedioEconomico,
                      borderColor: 'yellow',
                      borderWidth: 2,
                      label: {
                        // Background color of label, default below
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        // Font family of text, inherits from global
                        fontFamily: "sans-serif",
                        // Font size of text, inherits from global
                        fontSize: 12,
                        // Font style of text, default below
                        fontStyle: "bold",
                        // Font color of text, default below
                        fontColor: "#fff",
                        // Padding of label to add left/right, default below
                        xPadding: 6,
                        // Padding of label to add top/bottom, default below
                        yPadding: 6,
                        // Radius of label rectangle, default below
                        cornerRadius: 6,
                        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                        position: "right",
                        // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                        // For horizontal lines positioned left or right, negative values move
                        // the label toward the edge, and positive values toward the center.
                        xAdjust: 0,
                        // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                        // For vertical lines positioned top or bottom, negative values move
                        // the label toward the edge, and positive values toward the center.
                        yAdjust: 0,
                        // Whether the label is enabled and should be displayed
                        enabled: true,
                        // Text to display in label - default is null
                        content: "Promedio € ("+response.data.economico.promedioEconomico+")"
                      },
                      // Fires when the user clicks this annotation on the chart
                      // (be sure to enable the event in the events array below).
                      onClick: function(e) {
                        // `this` is bound to the annotation element
                      }
                    }
                  ],



                }
              }
            })
            .catch(error => {
              console.log(error);
            })
        },
        getChartEmpleado(){
          let formData = new FormData();

          formData.append('month', this.date.monthIndex);
          formData.append('year', this.date.year);
          formData.append('tour', this.selectTours.idioma);
          formData.append('empleado', this.empleado);
          formData.append('web', this.web);
          formData.append('chart', "empleado");

          axios.post('/get.charts.personas.php', formData)
            .then(response => {

              //this.dataChartMes = response.data;

              this.dataChartEmpleado = {
                labels: response.data.personas.labels,
                datasets: [
                  {
                    label: [response.data.economico.datasets.label],
                    //backgroundColor: response.data.datasets.backgroundColor,
                    data: response.data.economico.datasets.data,
                    type: 'line',
                    borderColor: "#ff9800"
                  },
                  {
                    label: [response.data.personas.datasets.label],
                    backgroundColor: response.data.personas.datasets.backgroundColor,
                    data: response.data.personas.datasets.data
                  }
                ]
              }
              this.totalPersonasEmpleado = response.data.personas.totalPersonas;
              this.totalPersonasEmpleadoBest = response.data.personas.totalPersonasBest;
              this.totalEconomicoEmpleado = response.data.economico.totalEconomico;
              this.totalEconomicoEmpleadoBest = response.data.economico.totalEconomicoBest;

              this.optionsChartEmpleado = {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero:true
                    }
                  }]
                },
                title: {
                  display: true,
                  text: 'Datos/Empleado'
                },
                annotation: {
                  // Defines when the annotations are drawn.
                  // This allows positioning of the annotation relative to the other
                  // elements of the graph.
                  //
                  // Should be one of: afterDraw, afterDatasetsDraw, beforeDatasetsDraw
                  // See http://www.chartjs.org/docs/#advanced-usage-creating-plugins
                  drawTime: 'afterDatasetsDraw', // (default)
                  // Mouse events to enable on each annotation.
                  // Should be an array of one or more browser-supported mouse events
                  // See https://developer.mozilla.org/en-US/docs/Web/Events
                  events: ['click'],
                  // Double-click speed in ms used to distinguish single-clicks from
                  // double-clicks whenever you need to capture both. When listening for
                  // both click and dblclick, click events will be delayed by this
                  // amount.
                  dblClickSpeed: 350, // ms (default)
                  // Array of annotation configuration objects
                  // See below for detailed descriptions of the annotation options
                  annotations: [{
                    // drawTime: 'afterDatasetsDraw', // overrides annotation.drawTime if set
                    id: 'a-line-1', // optional
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: response.data.personas.promedioPersonas,
                    borderColor: 'green',
                    borderWidth: 2,
                    label: {
                      // Background color of label, default below
                      backgroundColor: 'rgba(0,0,0,0.8)',
                      // Font family of text, inherits from global
                      fontFamily: "sans-serif",
                      // Font size of text, inherits from global
                      fontSize: 12,
                      // Font style of text, default below
                      fontStyle: "bold",
                      // Font color of text, default below
                      fontColor: "#fff",
                      // Padding of label to add left/right, default below
                      xPadding: 6,
                      // Padding of label to add top/bottom, default below
                      yPadding: 6,
                      // Radius of label rectangle, default below
                      cornerRadius: 6,
                      // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                      position: "left",
                      // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                      // For horizontal lines positioned left or right, negative values move
                      // the label toward the edge, and positive values toward the center.
                      xAdjust: 0,
                      // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                      // For vertical lines positioned top or bottom, negative values move
                      // the label toward the edge, and positive values toward the center.
                      yAdjust: 0,
                      // Whether the label is enabled and should be displayed
                      enabled: true,
                      // Text to display in label - default is null
                      content: "Promedio Personas ("+response.data.personas.promedioPersonas+")"
                    },
                    // Fires when the user clicks this annotation on the chart
                    // (be sure to enable the event in the events array below).
                    onClick: function(e) {
                      // `this` is bound to the annotation element
                    }
                  },

                    {
                      //drawTime: 'afterDraw', // overrides annotation.drawTime if set
                      id: 'a-line-2', // optional
                      type: 'line',
                      mode: 'horizontal',
                      scaleID: 'y-axis-0',
                      value: response.data.economico.promedioEconomico,
                      borderColor: 'yellow',
                      borderWidth: 2,
                      label: {
                        // Background color of label, default below
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        // Font family of text, inherits from global
                        fontFamily: "sans-serif",
                        // Font size of text, inherits from global
                        fontSize: 12,
                        // Font style of text, default below
                        fontStyle: "bold",
                        // Font color of text, default below
                        fontColor: "#fff",
                        // Padding of label to add left/right, default below
                        xPadding: 6,
                        // Padding of label to add top/bottom, default below
                        yPadding: 6,
                        // Radius of label rectangle, default below
                        cornerRadius: 6,
                        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                        position: "right",
                        // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                        // For horizontal lines positioned left or right, negative values move
                        // the label toward the edge, and positive values toward the center.
                        xAdjust: 0,
                        // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                        // For vertical lines positioned top or bottom, negative values move
                        // the label toward the edge, and positive values toward the center.
                        yAdjust: 0,
                        // Whether the label is enabled and should be displayed
                        enabled: true,
                        // Text to display in label - default is null
                        content: "Promedio € ("+response.data.economico.promedioEconomico+")"
                      },
                      // Fires when the user clicks this annotation on the chart
                      // (be sure to enable the event in the events array below).
                      onClick: function(e) {
                        // `this` is bound to the annotation element
                      }
                    }
                  ],



                }
              }
            })
            .catch(error => {
              console.log(error);
            })
        },
        getChartTour(){
          let formData = new FormData();

          formData.append('month', this.date.monthIndex);
          formData.append('year', this.date.year);
          formData.append('tour', this.selectTours.idioma);
          formData.append('web', this.web);
          formData.append('empleado', this.empleado);
          formData.append('chart', "tour");

          axios.post('/get.charts.personas.php', formData)
            .then(response => {

              //this.dataChartMes = response.data;

              this.dataChartTour = {
                labels: response.data.personas.labels,
                datasets: [
                  {
                    label: [response.data.economico.datasets.label],
                    //backgroundColor: response.data.datasets.backgroundColor,
                    data: response.data.economico.datasets.data,
                    type: 'line',
                    borderColor: "#ff9800"
                  },
                  {
                    label: [response.data.personas.datasets.label],
                    backgroundColor: response.data.personas.datasets.backgroundColor,
                    data: response.data.personas.datasets.data
                  }
                ]
              }
              this.totalPersonasTour = response.data.personas.totalPersonas;
              this.totalPersonasTourBest = response.data.personas.totalPersonasBest;
              this.totalEconomicoTour = response.data.economico.totalEconomico;
              this.totalEconomicoTourBest = response.data.economico.totalEconomicoBest;

              this.optionsChartTour = {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero:true
                    }
                  }]
                },
                title: {
                  display: true,
                  text: 'Datos/Mes-Tour-Empleado'
                },
                annotation: {
                  // Defines when the annotations are drawn.
                  // This allows positioning of the annotation relative to the other
                  // elements of the graph.
                  //
                  // Should be one of: afterDraw, afterDatasetsDraw, beforeDatasetsDraw
                  // See http://www.chartjs.org/docs/#advanced-usage-creating-plugins
                  drawTime: 'afterDatasetsDraw', // (default)
                  // Mouse events to enable on each annotation.
                  // Should be an array of one or more browser-supported mouse events
                  // See https://developer.mozilla.org/en-US/docs/Web/Events
                  events: ['click'],
                  // Double-click speed in ms used to distinguish single-clicks from
                  // double-clicks whenever you need to capture both. When listening for
                  // both click and dblclick, click events will be delayed by this
                  // amount.
                  dblClickSpeed: 350, // ms (default)
                  // Array of annotation configuration objects
                  // See below for detailed descriptions of the annotation options
                  annotations: [{
                    // drawTime: 'afterDatasetsDraw', // overrides annotation.drawTime if set
                    id: 'a-line-1', // optional
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: response.data.personas.promedioPersonas,
                    borderColor: 'green',
                    borderWidth: 2,
                    label: {
                      // Background color of label, default below
                      backgroundColor: 'rgba(0,0,0,0.8)',
                      // Font family of text, inherits from global
                      fontFamily: "sans-serif",
                      // Font size of text, inherits from global
                      fontSize: 12,
                      // Font style of text, default below
                      fontStyle: "bold",
                      // Font color of text, default below
                      fontColor: "#fff",
                      // Padding of label to add left/right, default below
                      xPadding: 6,
                      // Padding of label to add top/bottom, default below
                      yPadding: 6,
                      // Radius of label rectangle, default below
                      cornerRadius: 6,
                      // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                      position: "left",
                      // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                      // For horizontal lines positioned left or right, negative values move
                      // the label toward the edge, and positive values toward the center.
                      xAdjust: 0,
                      // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                      // For vertical lines positioned top or bottom, negative values move
                      // the label toward the edge, and positive values toward the center.
                      yAdjust: 0,
                      // Whether the label is enabled and should be displayed
                      enabled: true,
                      // Text to display in label - default is null
                      content: "Promedio Personas ("+response.data.personas.promedioPersonas+")"
                    },
                    // Fires when the user clicks this annotation on the chart
                    // (be sure to enable the event in the events array below).
                    onClick: function(e) {
                      // `this` is bound to the annotation element
                    }
                  },

                    {
                      //drawTime: 'afterDraw', // overrides annotation.drawTime if set
                      id: 'a-line-2', // optional
                      type: 'line',
                      mode: 'horizontal',
                      scaleID: 'y-axis-0',
                      value: response.data.economico.promedioEconomico,
                      borderColor: 'yellow',
                      borderWidth: 2,
                      label: {
                        // Background color of label, default below
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        // Font family of text, inherits from global
                        fontFamily: "sans-serif",
                        // Font size of text, inherits from global
                        fontSize: 12,
                        // Font style of text, default below
                        fontStyle: "bold",
                        // Font color of text, default below
                        fontColor: "#fff",
                        // Padding of label to add left/right, default below
                        xPadding: 6,
                        // Padding of label to add top/bottom, default below
                        yPadding: 6,
                        // Radius of label rectangle, default below
                        cornerRadius: 6,
                        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                        position: "right",
                        // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                        // For horizontal lines positioned left or right, negative values move
                        // the label toward the edge, and positive values toward the center.
                        xAdjust: 0,
                        // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                        // For vertical lines positioned top or bottom, negative values move
                        // the label toward the edge, and positive values toward the center.
                        yAdjust: 0,
                        // Whether the label is enabled and should be displayed
                        enabled: true,
                        // Text to display in label - default is null
                        content: "Promedio € ("+response.data.economico.promedioEconomico+")"
                      },
                      // Fires when the user clicks this annotation on the chart
                      // (be sure to enable the event in the events array below).
                      onClick: function(e) {
                        // `this` is bound to the annotation element
                      }
                    }
                  ],



                }

              }
            })
            .catch(error => {
              console.log(error);
            })
        },
      fillData () {
        this.getChartMes();
        this.getChartYear();
        this.getChartEmpleado();
        this.getChartTour();

      },
    getEmpleados(){
        let formData = new FormData();

        formData.append('month', this.date.month);
        formData.append('year', this.date.year);
        formData.append('tour', this.selectTours.idioma);
        formData.append('web', this.web);

        axios.post('/get.empleados.php', formData)
            .then(response => {

                this.empleados = response.data;

                this.fillData();

            })
            .catch(error => {
                console.log(error);
            })

    },
    complete (index) {
      this.list[index] = !this.list[index]
    },
    showDate (date) {
      this.date = date
      this.fillData()
    }
  }
}
</script>
<style>
    .month-picker-input-container{
        width: 100% !important;
    }
    .month-picker-input{
        background-color: #FFF;
        width: 100% !important;
    }
    .month-picker-container{
        background-color: #FFF;
        z-index: 99998;
        width: 100% !important;
    }
    .month-picker-container button{
        background-color: #FFF;
        z-index: 99999;
    }
    .month-picker-container button:hover{
        background-color: #FFF;
        z-index: 99999;
    }
    .fondoBlanco{
        background-color: #fff;

        border-color: #fff;

        color: rgba(0,0,0,.87);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

        border-radius: 3px;
    }
</style>